import React, { useState } from 'react'
import DataTable, { defaultThemes } from 'react-data-table-component'

function TableComplaints() {
    
    const customStyles = {

        rows: {
            style: {
                '&:nth-child(odd)': {
                    backgroundColor: '#F5F8FA',
                    minHeight: '50px',
                    
                },
                '&:nth-child(even)': {
                    backgroundColor: 'white',
                    minHeight: '50px'
                },
                '&:nth-child(1)': {
                    backgroundColor: '#F5F8FA',
                    minHeight: '50px'
                },
                '&:nth-child(2)': {
                    backgroundColor: 'white',
                    minHeight: '50px'
                },
            },
        },
        header: {
            style: {
                minHeight: '4px',
                
            },
        },
        headRow: {
            style: {
                borderTopStyle: 'solid',
                borderTopWidth: '1px',
                borderTopColor: defaultThemes.default.divider.default,
                backgroundColor:'#18A0FB',
                color:'white',
                height:'50px',
                
            },
        },
        headCells: {
            style: {
                '&:not(:last-of-type)': {
                    borderRightStyle: 'solid',
                    borderRightWidth: '1px',
                    borderRightColor: defaultThemes.default.divider.default,
                },
            },
        },
        cells: {

            style: {
                '&:not(:last-of-type)': {
                    borderRightStyle: 'solid',
                    borderRightWidth: '1px',
                    borderRightColor: defaultThemes.default.divider.default,
                    
                    

                   
                },
            },
           
            
        },



    };

    const columns = [
        {
            name: 'Sl No',
            selector: row => row.slno,
            sortable: true,
            
            
        },
        {
            name: 'Complaint',
            selector: row => row.complaint,
            sortable: true,
            
            
        },
        {
            name: 'Reported Date',
            selector: row => row.reporteddate,
            sortable: true,
        },
        {
            name: 'Video Id',
            selector: row => row.videoid,
            sortable: true,
        },
        {
            name: 'Action Taken',
            selector: row => row.actiontaken,
            sortable: true,
        },
       {
            name: 'Action',
            selector: row => row.Action,
            // sortable: true,
        },
    ];
    var data = []
    for (let i = 0; i < 50; i++) {
        const id = i + 1; // Assuming ids start from 1
        const slno = id
        const complaint = `complaint `;
        const reporteddate = `${i < 30 ? 1 + i : -31 + i + 2} - 10 - 2020`;
        const videoid =  `cbhewbfhb43r843tfhh4837${id}`
        const actiontaken=<span className={`${id<25?'bg-green-600':'bg-red-600'} rounded-full p-2 text-white `}>{id<25?'Solved':'Unsolved'}</span>
        const Action = <a style={{color:'#18A0FB',cursor:'pointer'}}>See More</a>;


        const newObj = { id,slno, complaint, reporteddate, videoid,actiontaken,Action };
        data.push(newObj);
    }





    return (
        <>
       
        <DataTable
            title="Complaint List"
            columns={columns}
            data={data}
            customStyles={customStyles}
            pagination
            dense
            highlightOnHover
            selectableRowsHighlight
            // selectableRows
            // progressPending
            // progressComponent={<h1>load</h1>}
    

        />
        </>
    )
}

export default TableComplaints